import { Card, CardBody, Col } from "reactstrap";
import { VerticalStyleTitle } from "../../../../../../Constants/Constants";
import { VerticalStyleSubTitle } from "../../../../../../Data/Forms&Table/Forms/FormControls";
import CommonCardHeader from "../../../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import CommonCardFooter from "../../../Common/CommonCardFooter";
import VerticalStyleForm from "./VerticalStyleForm";

const VerticalStyle = () => {
  return (
    <Col sm="12" xxl="6" className="box-col-12">
      <Card className="height-equal">
        <CommonCardHeader title={VerticalStyleTitle} span={VerticalStyleSubTitle} />
        <CardBody>
          <VerticalStyleForm />
        </CardBody>
        <CommonCardFooter footerClass="text-end" color1="primary" color2="light" />
      </Card>
    </Col>
  );
};
export default VerticalStyle;
